import * as React from 'react';
import { Avatar } from './Avatar';
import { Icon, iconName, IconSize } from '../icons/Icons';
import { colors } from '../colors/color';

export type IconAvatarProps = {
    icon:iconName,
    size?:string,
    iconSize?: IconSize,
    identifier?:string,
    backgroundColor?:string,
    contentColor?:string,
    borderColor?:string,
    selected?:boolean,
    toolTip?:React.ReactNode,
    onClick?: (identifier:string) => void
};

export function IconAvatar (props: IconAvatarProps): JSX.Element
{
    return (
        <Avatar
            {...props} size={props.size || '24px'}>

            <Icon name={props.icon} 
                color={props.contentColor || colors.avatar.text} 
                size={props.iconSize || 'small'} />

        </Avatar>
    );
}
